import { Divider, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import DialogModal from 'components/UI/DialogModal';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    open: boolean;
    vendors: any;
    venues: any;
    modalities: any;
    topic: any;
    countries: any;
    cities: any;
    languages: any;
    filters: any;
    onClose: () => void;
    onReset: () => void;
    onChangeVendor: (value: any) => void;
    onChangeVenues: (value: any) => void;
    onChangeModalities: (value: any) => void;
    onChangeTopic: (value: any) => void;
    onChangeCountries: (value: any) => void;
    onChangeCities: (value: any) => void;
    onChangeLanguages: (value: any) => void;
};


const CalendarFilterModal: React.FC<Props> = ({ open, vendors, venues, modalities, topic, countries,
    cities, languages,
    filters, onClose, onChangeVendor, onChangeModalities, onChangeVenues, onChangeTopic, onReset,
    onChangeCountries, onChangeCities, onChangeLanguages
}) => {
    const { t } = useTranslation();
    return (
        <>
            <DialogModal
                open={open}
                onClose={onClose}
                title={t('T_filter_calender')}
                maxWidth="md"
                sx={{
                    "& .MuiDialog-paper": {
                        borderRadius: 3,
                        minHeight: "100%",
                        overflow: "hidden",
                    },
                }}
                children={
                    <>
                        <Grid container spacing={2} sx={{
                            mt: 2,
                        }}>
                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl
                                    variant="outlined"
                                    style={{
                                        minWidth: 220,
                                        maxWidth: 220,
                                    }}
                                >
                                    <InputLabel>{t("T_vendors")}</InputLabel>
                                    <Select
                                        value={vendors}
                                        onChange={onChangeVendor}
                                        label={t("T_vendors")}

                                    >
                                        {filters?.vendors.map((vendor: any, i: number) => (
                                            <MenuItem key={i} value={vendor.id}>
                                                {vendor.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                          
                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl
                                    variant="outlined"
                                    style={{ minWidth: 220, maxWidth: 220, }}
                                >
                                    <InputLabel>{t("T_modalities")}</InputLabel>
                                    <Select
                                        value={modalities}
                                        onChange={onChangeModalities}
                                        label={t("T_modalities")}
                                    >
                                        {filters?.modalities.map((modality: any) => (
                                            <MenuItem value={modality.id}>{modality.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl
                                    variant="outlined"
                                    style={{ minWidth: 220, maxWidth: 220, }}
                                >
                                    <InputLabel>{t("T_topics")}</InputLabel>
                                    <Select
                                        value={topic}
                                        onChange={onChangeTopic}
                                        label={t("T_topics")}
                                    >
                                        {filters?.topics.map((topic: any) => (
                                            <MenuItem value={topic.id}>{topic.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl
                                    variant="outlined"
                                    style={{ minWidth: 220, maxWidth: 220, }}
                                >
                                    <InputLabel>{t("T_countries")}</InputLabel>
                                    <Select
                                        value={countries}
                                        onChange={onChangeCountries}
                                        label={t("T_countries")}
                                    >
                                        {filters.countries?.map((country: any) => (
                                            <MenuItem value={country.id}>{country.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl
                                    variant="outlined"
                                    style={{ minWidth: 220, maxWidth: 220, }}
                                >
                                    <InputLabel>{t("T_cities")}</InputLabel>
                                    <Select
                                        value={cities}
                                        onChange={onChangeCities}
                                        label={t("T_cities")}
                                        disabled={!countries}
                                    >
                                        {filters.cities && filters.cities.filter((city: any) => city.countryId === countries)
                                            ?.map((city: any) => (
                                                <MenuItem value={city.id}>{city.name}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl
                                    variant="outlined"
                                    style={{ minWidth: 220, maxWidth: 220 }}
                                >
                                    <InputLabel>{t("T_venus")}</InputLabel>
                                    <Select
                                        value={venues}
                                        onChange={onChangeVenues}
                                        label={t("T_venus")}
                                    >
                                        {filters?.venues && cities ? filters?.venues.filter((venue: any) => venue.cityId === cities).map((vendue: any) => (
                                            <MenuItem value={vendue.id}>{vendue.name}</MenuItem>
                                        )) : filters?.venues
                                            .map((vendue: any) => (
                                                <MenuItem value={vendue.id}>{vendue.name}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl
                                    variant="outlined"
                                    style={{ minWidth: 220, maxWidth: 220, }}
                                >
                                    <InputLabel>{t("T_languages")}</InputLabel>
                                    <Select
                                        value={languages}
                                        onChange={onChangeLanguages}
                                        label={t("T_languages")}
                                    >
                                        {filters.languages?.map((lang: any) => (
                                            <MenuItem value={lang.id}>{lang.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>

                                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                                    <Button
                                        variant="text"
                                        color="primary"
                                        onClick={onClose}
                                        style={{
                                            marginInline: "10px",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {t("T_close")}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={onReset}
                                        style={{
                                            marginInline: "10px",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {t("T_reset")}
                                    </Button>
                                </Stack>
                            </Grid>

                        </Grid>
                    </>
                }
            />
        </>
    );
}

export default CalendarFilterModal;